import {PLUGIN_VERSION} from '../constants'

export const PLUGIN_VERSION_QUERY = {
  sanityVersion: PLUGIN_VERSION,
}
